import React from "react";
import {Delete, translate} from "admin-on-rest";
import SuppressionsDataList from "./SuppressionsDataList";

///////////////////// LIST ALL CUSTOMERS /////////////////////
export const SuppressionsList = props => <SuppressionsDataList {...props} />;

///////////////////// DELETE CUSTOMER /////////////////////

const SuppressionsDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}&nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.first_name} ${record.last_name}`}
  </span>
);

const SuppressionsDeleteTitle = translate(SuppressionsDeleteTitleBase);

export const SuppressionsDelete = props => (
  <Delete {...props} title={<SuppressionsDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/Suppressions/index.js